<div class="layout-ParentDiv innerDiv">
  <div class="layout-dashboard">
    <p-toast key="toastmsg"></p-toast>
    <div class="mainDivHeader">
      <div class="leftdiv">
        <h4>Tournament Report<span class="badge">{{totalRecords}}</span></h4>
      </div>
      <div class="rightDiv">
        <button class="exportBTn" pTooltip="XLS" tooltipPosition="bottom" (click)="exportExcel()" label="Export"
          icon="pi pi-file-excel"> <span><img src="../../../assets/images/backend-image/header/exportIcon.svg"
              alt=""></span>
          Export</button>
      </div>
    </div>
    <div class="mainDivBody">
      <div class="date-filterDiv">
        <ul class="filtersList">
          <li>
            <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
              optionLabel="label"></p-dropdown>
          </li>
          <li>
            <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
              class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
              placeholder="FROM: dd / mm / yy"></p-calendar>
          </li>
          <li>
            <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
              class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
              placeholder="TO: dd / mm / yy"></p-calendar>
          </li>
          <li>
            <button (click)="tournamentReportList($event)" class="searchFilterBtn">
              <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
            </button>
          </li>
          <li>
            <button (click)="clear()" class="clearFilterBtn">
              <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
              <span>Clear All</span>
            </button>
          </li>
        </ul>
      </div>
      <div class="maintableDiv">
        <div class="tableParanet">
          <p-table class="expandable" #dt [value]="tournament" [autoLayout]="true" [paginator]="true" [rows]="10"
            [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
            (onLazyLoad)="tournamentReportList($event)" [totalRecords]="totalRecords" [loading]="loading"
            [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th pfrozencolumn="" class="p-element text-nowrap nameTD" pSortableColumn="tdsSection">
                  <div class="p-d-flex p-jc-between p-ai-center"> Name <p-sortIcon field="deductee"></p-sortIcon>
                  </div>
                </th>
                <th pfrozencolumn="" class="p-element text-nowrap startdateTD" pSortableColumn="pan">
                  <div class="p-d-flex p-jc-between p-ai-center"> Start Date <p-sortIcon field="pan"></p-sortIcon>
                  </div>
                </th>
                <th pfrozencolumn="" class="p-element text-nowrap stateTD" pSortableColumn="deductee">
                  <div class="p-d-flex p-jc-between p-ai-center"> State <p-sortIcon field="deductee"></p-sortIcon>
                  </div>
                </th>
                <th pSortableColumn="created_at" class="cityTD">
                  <div class="p-d-flex p-jc-between p-ai-center"> City <p-sortIcon field="created_at"></p-sortIcon>
                  </div>
                </th>
                <th class="playercountTD" pSortableColumn="withdrawId">
                  <div class="p-d-flex p-jc-between p-ai-center"> Player Count <p-sortIcon
                      field="transferAmount"></p-sortIcon>
                  </div>
                </th>
                <th class="categoryTD" pSortableColumn="created_at">
                  <div class="p-d-flex p-jc-between p-ai-center"> Category Count <p-sortIcon field="tds"></p-sortIcon>
                  </div>
                </th>
              </tr>
              <tr>
                <th class="nameTD">
                  <input pInputText type="text"
                    (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'name', 'contains')"
                    [value]="dt.filters['name'] ? dt.filters['name'].value : ''" [(ngModel)]="name" />
                </th>
                <th class="startdateTD">
                  <p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                    (onSelect)="setDownloadFlag(); dt.filter($event,'start_date', 'dateIs')" [(ngModel)]="calvalue"
                    class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
                </th>
                <th class="stateTD">
                  <input pInputText type="text"
                    (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'statename', 'contains')"
                    [value]="dt.filters['statename'] ? dt.filters['statename'].value : ''" [(ngModel)]="statename" />
                </th>
                <th class="cityTD">
                  <input pInputText type="text"
                    (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'cityname', 'contains')"
                    [value]="dt.filters['cityname'] ? dt.filters['cityname'].value : ''" [(ngModel)]="cityname" />
                </th>
                <th class="playercountTD">
                  <input pInputText type="text"
                    (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'playerCount', 'contains')"
                    [value]="dt.filters['playerCount'] ? dt.filters['playerCount'].value : ''"
                    [(ngModel)]="playerCount" />
                </th>
                <th class="categoryTD">
                  <input pInputText type="text"
                    (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'categoryCount', 'contains')"
                    [value]="dt.filters['categoryCount'] ? dt.filters['categoryCount'].value : ''"
                    [(ngModel)]="categoryCount" />
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-tournament>
              <tr class="p-selectable-row">
                <td pfrozencolumn="" class="p-element text-nowrap nameTD">
                  <div class="tournamentNameText" [pTooltip]="tournament?.name" tooltipPosition="bottom">
                    {{ tournament?.name }}
                  </div>
                </td>
                <td class="p-element text-nowrap startdateTD">
                  {{ tournament?.startdate | date:'dd/MM/yyyy' }}
                </td>
                <td class="p-element text-nowrap stateTD">
                  {{ tournament?.statename }}
                </td>
                <td class="cityTD">
                  {{ tournament?.cityname }}
                </td>
                <td class="playercountTD">
                  {{ tournament?.playerCount}}
                </td>
                <td class="categoryTD">
                  {{ tournament?.categoryCount }}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="6">Tournament report list not found.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>
